import { DSButton } from "@components/design-system/molecules";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const AddStepButtons = ({ onAddPressStep, onAddWaitStep }) => {
  return (
    <div className="flex justify-center gap-4">
      <DSButton variant="secondary" onClick={onAddPressStep}>
        <FontAwesomeIcon icon={faPlus} className="mr-2" />
        Add Press Step
      </DSButton>
      <DSButton variant="secondary" onClick={onAddWaitStep}>
        <FontAwesomeIcon icon={faPlus} className="mr-2" />
        Add Wait Step
      </DSButton>
    </div>
  );
};

export default AddStepButtons;
